module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.3/frontend/_next/static/images/garden-353113c0a869f276535251e6edcb7784.jpg";